function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.3125 2.47498C8.24119 2.47725 6.25538 3.30108 4.79074 4.76572C3.32611 6.23035 2.50227 8.21617 2.5 10.2875V16.85C2.5 17.1815 2.6317 17.4994 2.86612 17.7339C3.10054 17.9683 3.41848 18.1 3.75 18.1H10.3125C12.3845 18.1 14.3716 17.2769 15.8368 15.8117C17.3019 14.3466 18.125 12.3595 18.125 10.2875C18.125 8.21547 17.3019 6.22833 15.8368 4.7632C14.3716 3.29808 12.3845 2.47498 10.3125 2.47498ZM10.3125 16.85H3.75V10.2875C3.75 8.98954 4.13488 7.72074 4.85598 6.64155C5.57708 5.56235 6.602 4.72122 7.80114 4.22452C9.00028 3.72782 10.3198 3.59786 11.5928 3.85107C12.8658 4.10429 14.0351 4.72931 14.9529 5.64709C15.8707 6.56487 16.4957 7.73419 16.7489 9.0072C17.0021 10.2802 16.8722 11.5997 16.3755 12.7988C15.8788 13.998 15.0376 15.0229 13.9584 15.744C12.8792 16.4651 11.6104 16.85 10.3125 16.85Z",
  fill: "#002A36"
});

var SvgComment = function SvgComment(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgComment, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comment.d94e652d.svg";
export { ForwardRef as ReactComponent };